// extracted by mini-css-extract-plugin
export var menuIcon = "_qt-0";
export var menuIconInline = "_qt-1";